<div [formGroup]="formGroup">
  <div style="display: flex; align-items: center; justify-content: center">
    <div class="radio-group" style="max-width: 50vw">
      <label class="radio-option"
             *ngFor="let option of control.element.options"
             [ngStyle]="{'border-color': option.id === control.element.option ? '#3e6487' : ''}">
        <input
          type="radio"
          [formControlName]="control.element.id"
          [name]="control.element.id"
          [id]="option.label"
          [value]="option.label"
          (change)="onSelectionChange(option.id)"
        />
        <div class="radio-option-content" style="user-select: none">
          <h3 class="radio-option-title" style="color: black">{{ option.label }}</h3>
          <p class="radio-option-description" style="margin-bottom: 0; color: black">{{ option.description }}</p>
        </div>
      </label>
    </div>
  </div>
</div>
